<template>
  <div class="loading-container">
    <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/all-logo2.png" class="all-logo" />
    <div class="loading-progress">
      <div class="progress-bar" v-if="!showBtn">
        <div class="progress-bar-inner" :style="{ width: progress + '%' }">
          <span>{{ progress }}</span> <span>%</span>
        </div>
      </div>
    </div>

    <img v-if="showBtn" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/loading-btn.png" class="loading-btn" @click="start" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      progress: 0,
      loadCount: 0,
      showBtn: false,
      // fileList: ["../../assets/images/bg-long.jpg"]
      fileList: [
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/music.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/3/cover-text-6.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/4/cover-book.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/cover2.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/3/cover1_2.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cover/3/logo2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/brave.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/cz.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/flp.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/fpj.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/js.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/liangshan.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/smy.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/wyb.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/zsf.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/bg1_7.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/endplay.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/gif2/live-liked.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/gif2/live-un-like.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/peoples.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/talk3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/talk4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/talk5.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/wang-person3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/person1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/play-mp41.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/play-mp42.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/pangxie.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/person1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk5.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/4/talk1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/3/dianzan.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/title1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/hand.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/hand2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/hand3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5_c.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/air.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/talk3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/c1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/c2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/q1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/q2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/a1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/a2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/caifang_wang.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/person2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/field/2/live.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/live-title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/bg.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/person2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/talk1_2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/play-mp4_1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/talk1_1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/3/q1.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/3/q2.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/5/talk11.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/A4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/A4-talk.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/talk12.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/talk5.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/5/talk6.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/vote-bg.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/vote.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/vote2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/vote-result.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/before-vote2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/after-vote.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/4/record.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/c.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/3/a1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/a2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/q1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/2/q2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/person4_1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/shuji/nver.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/bg.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/pic1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/pic2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/pic3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/pic4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/btn3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/talk12.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/talk9.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/talk1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/q1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/q2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/c.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/talk11.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/talk8.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/talk14.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/tlk15.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/a1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/talk13.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/4/a2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/fish2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person5.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/person6.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/3/head_3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/play-mp4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/2/before2.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/camera/fish.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/bg.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/2/logo.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/timeline/2/timeline.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/comment/bg12.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/comment/comment-title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/video-mask3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/play-mp4_1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/play-mp4_2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk1_1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk9.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/circle.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/chandou.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk10.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/before-btn.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/before.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/gif2/xt.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/gif2/xdt.gif',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk3_1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk5.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/4/person8.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/c1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk6.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk7.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/fire.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/pic1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person5.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk8.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person7.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person6.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/bg2.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/talk4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/person3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/talk1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/person2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/3/talk3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/ganyan.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/person1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/3/pic1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/3/pic2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/4/talk2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/play-mp4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/bg.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/title.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/4/talk6.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/talk7.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/pic3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/q1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/4/a1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/4/person5_2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/talk1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/talk8.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/talk9.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/c1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/c2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/q2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/q3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/q4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/4/a2.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/a3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/4/a4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/talk10.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/4/talk11.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/talk12.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/person3.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/person4.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/play-mp41.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/play-mp42.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/2/person1.png',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/4/bg.jpg',
        'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/liangshan/video-mask.png'
      ]
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    start() {
      this.$emit('loadSuccess')
    },
    initLoad() {
      for (let i = 0; i < this.fileList.length; i++) {
        this.loadFile(this.fileList[i])
      }
    },
    loadFile(url) {
      const extension = url
        .split('.')
        .pop()
        .toLowerCase()
      if (extension === 'mp3') {
        // 音频流文件预加载
        const audio = new Audio()
        audio.src = url
        audio.addEventListener('canplaythrough', () => {
          this.loadSuccess()
        })
      } else if (extension === 'mp4') {
        // 视频流文件预加载 无法处理 只能通过video标签处理
        this.loadSuccess()
      } else {
        const img = new Image()
        img.src = url
        img.onload = () => {
          this.loadSuccess()
        }
      }
    },
    loadSuccess() {
      this.loadCount++
      this.progress = parseInt((this.loadCount / this.fileList.length) * 100)
      if (this.loadCount === this.fileList.length) {
        // this.$emit('loadSuccess')
        this.showBtn = true
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.initLoad()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
$originWidth: 1920;
$originHeight: 919;
.loading-container {
  position: fixed;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #9b3c28;
  flex-direction: column;
  background-image: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/loading/loading-bg5.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .all-logo {
    position: absolute;
    width: percentage(288 / $originWidth);
    height: percentage(41 / $originHeight);
    left: percentage(67 / $originWidth);
    top: percentage(62 / $originHeight);
  }
  .loading-btn {
    position: absolute;
    width: percentage(255 / $originWidth);
    height: percentage(93 / $originHeight);
    left: percentage(828 / $originWidth);
    top: percentage(678 / $originHeight);
    animation: scale-up 1s infinite;
    cursor: pointer;
  }
  @keyframes scale-up {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
  .loading-progress {
    position: absolute;
    width: percentage(433 / $originWidth);
    left: percentage(744 / $originWidth);
    top: percentage(541 / $originHeight);
    // height: percentage(156 / $originHeight);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .progress-wenzi {
    font-size: 26px;
    color: #ffebbc;
  }
  .progress-bar {
    width: 100%;
    height: 20px;
    border-radius: 20px;
    border: 2px solid #e1b790;
    overflow: hidden;
    line-height: 20px;
    text-align: center;
    font-weight: 600;
    color: #9b3c28;
    .progress-bar-inner {
      background-color: #ffebbc;
      height: 100%;
      transition: width 0.3s;
    }
  }

  .progress-text {
    font-size: 80px;
    color: #ffebbc;

    & span:nth-child(2) {
      font-size: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading/index.vue